// fb-220: ONE "legacy" pill for menu entries scheduled for removal (left menu + top-menu dropdown).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { plainText } from './ActionIcons';

export const LEGACY_SECTIONS = new Set([
  'finance/record-expense', 'finance/record-payment', 'finance/record-other-revenue',
  'inventory/adjustments', 'inventory/transfers', 'farm-ops/record-operations',
  'purchasing/purchase-entry',   // fb-220
]);

export default function LegacyPill({ cls = 'badge' }) {
  const { t } = useTranslation('common');
  return <span className={cls} title={plainText(t('legacy.pillTitle'))} style={{ background: '#fff7ed', color: '#9a3412', border: '1px solid #fed7aa', fontSize: 9, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em' }}>{t('legacy.pill')}</span>;
}
